export default __webpack_public_path__ + "static/media/AFAribbonCAP.720bb634.jpg";